import React from "react"
import Avatar from "material-ui/Avatar"
import Chip from "material-ui/Chip"
import autobind from "class-autobind"
import strings from "../../localization/strings"
import FontIcon from "material-ui/FontIcon"
import IconButton from "material-ui/IconButton"
import AddEmployeeDialogForChip from "./AddEmployeeDialogForChip"
import ImageLoader from "../misc/ImageLoader"
import { IUIUser, IUserDocument } from "../../models"
interface IProps {
	selectedEmployee: IUIUser | IUserDocument
	errEmployee?: boolean
	readonly?: boolean
	filterByLevel?: boolean
	setEmployee?(employee: IUIUser): void
}
interface IState {
	selectedEmployee: IUIUser
	showAddEmployee: boolean
	errEmployee: boolean
}

export default class EmployeeChip extends React.Component<IProps, IState> {
	static defaultProps = {
		filterByLevel: false
	}

	constructor(props) {
		super(props)
		this.state = {
			selectedEmployee: props.selectedEmployee,
			showAddEmployee: false,
			errEmployee: false
		}
		autobind(this)
	}

	componentWillReceiveProps(nextProps) {
		this.setState({
			errEmployee: nextProps.errEmployee,
			selectedEmployee: nextProps.selectedEmployee
		})
	}

	handleRequestDelete() {
		this.setState({ selectedEmployee: null })
		this.props.setEmployee(null)
	}

	handleAddEmployeeDialog() {
		this.setState({
			showAddEmployee: !this.state.showAddEmployee,
			errEmployee: false
		})
	}

	handleAddEmployee(selectedEmployee: IUIUser) {
		this.handleAddEmployeeDialog()
		this.setState({ selectedEmployee })
		this.props.setEmployee(selectedEmployee)
	}

	render() {
		const { selectedEmployee, errEmployee } = this.state
		return (
			<div style={{ marginTop: 10, marginBottom: 10, display: "inline-block" }}>
				<div style={{ fontSize: 12, color: "rgba(0, 0, 0, 0.298)" }}>
					{strings.Employee}
					{errEmployee &&
						<span style={{ color: "rgb(244, 67, 54)", marginLeft: 10 }}>
							{strings.Employee_is_required}
						</span>
					}
				</div>
				{selectedEmployee &&
					<Chip
						data-intercom-target={"Select Employee"}
						onRequestDelete={!this.props.readonly ? this.handleRequestDelete : null}
						style={{ display: "flex", alignItems: "center", cursor: "pointer", marginTop: 4, height: 42 }}
						deleteIconStyle={{ marginRight: 4, marginLeft: -8, marginTop: 0, marginBottom: 0 }}
					>
						{selectedEmployee.ProfileImageS3Url &&
							<Avatar style={{ width: 42, height: 42 }}>
								<ImageLoader url={selectedEmployee.ProfileImageS3Url} fixedHeight={75} avatar={true} src={"/users/profileimage/" + selectedEmployee.ProfileImageS3Url} />
							</Avatar>
						}
						{selectedEmployee.FirstName + " " + selectedEmployee.LastName}
						{selectedEmployee.ExternalId && " - " + selectedEmployee.ExternalId}
					</Chip>
				}
				{!this.props.readonly && !selectedEmployee &&
					<IconButton data-intercom-target={"Btn-OpenEmployeeSelectionDialog"} style={{ height: 35, width: 35, padding: 0, margin: 0, display: "inline-block" }} onTouchTap={this.handleAddEmployeeDialog}>
						<FontIcon className="fa fa-plus-circle" />
					</IconButton>
				}
				{this.state.showAddEmployee &&
					<AddEmployeeDialogForChip
						singleSelectable
						handleClose={this.handleAddEmployeeDialog}
						open={this.state.showAddEmployee}
						handleAddEmployees={selectedEmployees => this.handleAddEmployee(selectedEmployees[0])}
						filterByLevel={this.props.filterByLevel}
					/>
				}
			</div>
		)
	}
}
